/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconOnlineSecurity extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "OnlineSecurityIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><title>Online security</title><g><rect width="64" height="64" fill="none"></rect><rect x="7.5" y="10.86" width="48.99" height="36.74" fill="#d4cdd1"></rect><polygon points="56.5 47.6 7.5 47.6 1.67 47.6 1.67 53.14 62.33 53.14 62.33 47.6 56.5 47.6" fill="#d4cdd1"></polygon><rect x="11.11" y="14.45" width="41.78" height="29.55" fill="#37474f"></rect><path d="M36,26.44a4.93,4.93,0,0,0-1-3.12A3.74,3.74,0,0,0,32,22a3.78,3.78,0,0,0-3,1.36,4.88,4.88,0,0,0-1,3.1v1.18H26.35v7.88H37.65V27.62H36Zm-1.69,1.18H29.74V26.44a3.27,3.27,0,0,1,.58-2A2,2,0,0,1,32,23.67a1.94,1.94,0,0,1,1.68.71,3.3,3.3,0,0,1,.58,2.06Z" fill="#d4cdd1"></path></g></svg>
    `;
}
